import Logout from './logout-container';

export default Logout;
